/**
 * Dawn: predictive-search.js (SAFE PATCH)
 * If <predictive-search> isn't present, do nothing (prevents Theme Editor spinner).
 * Keeps default behavior when the element exists.
 */

class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    // If the internal form is missing, bail without crashing
    this.searchForm = this.querySelector('form');
    this.input = this.querySelector('input[type="search"], input[name="q"]');

    if (!this.searchForm || !this.input) return;

    this.onChange = this.onChange.bind(this);
    this.input.addEventListener('input', this.onChange);
  }

  onChange() {
    // Minimal no-op implementation so Dawn doesn’t crash.
    // If you re-enable predictive search later, we can restore full Dawn behavior.
  }
}

// Define only once
if (!customElements.get('predictive-search')) {
  customElements.define('predictive-search', PredictiveSearch);
}